import SLMSaleList from "containers/slm/SLMSaleList";
import SLMOwnerIsCompanyMapping from "containers/slm/SLMOwnerIsCompanyMapping";
import React, { Component } from "react";
import { Button, Col, Container, Form, Row, Modal } from "react-bootstrap";
import "react-table/react-table.css";
import { API } from "aws-amplify";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Moment from "moment";
// import { s3GetURL, s3Upload } from "lib/awsLib";
import { PacmanLoader } from "react-spinners";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class SLMSalesSearch extends Component {
  constructor(props) {
    super(props);
    this.updateTableState = this.updateTableState.bind(this);
    this.file = null;

    this.state = {
      searching: false,
      stateOptions: [],
      selectedState: null,
      sales: [],
      salesExport: [],
      ownerIsCompanyMapping: [],
      showIndividualBuyerSeller: false,
      clientExports: [{ value: "CBRE", label: "CBRE sales" }], //,{value: "NAB", label: "Valex/NAB"},{vale: "CL", label: "CL Research"}, {value: "GAP", label: "Gap Maps"}, {value: "ONE", label: "One Map"}],
      cbreHeaderRow: ["UniquePIMSaleID", "PIMSaleID", "DeliveryDate", "PreviousDeliveryDate", "PropertyAddress", "StreetNumLow", "StreetNumHigh", "streetName", "StreetExt", "addressSuburb", "addressState", "addressPC", "floorUnit", "buildingName", "isSOLD", "saleMethod", "saleDescriber", "InterestTransferred", "Price", "PriceEstimated", "SaleDate", "ContractDate", "TransferDate", "IncomePerAnnum", "IncomePerAnnumBasis", "yield", "PricePerSQMLand", "PricePerSQMBuilding", "BuyerNames", "VendorNames", "SellingAgency", "SellingAgent", "PropertyTitleBasis", "PropertyStatus", "BroadSpaceUse", "DetailedSpaceUse", "siteArea", "BuildingArea", "BuildingAreaBasis", "Storeys", "YearBuilt", "YearRefurbished", "CarParking", "CarParkingDescription", "frontage", "Zoning", "QualityIndicator", "SaleNotes", "saleSource1", "sourceDate1", "saleSource2", "sourceDate2", "saleSource3", "sourceDate3", "printMonth"],
      selectedClientExport: null,
      selectedSpaceUseCategories: null,
      selectedBroadSpaceUseCategories: null,
      selectedTitleBasisCategories: null,
      selectedSaleMethodCategories: null,
      createdby: null,
      editedby: null,
      printdatefrom: null,
      printdateto: null,
      statdatefrom: null,
      statdateto: null,
      pricefrom: null,
      priceto: null,
      pricepsqmbuildingfrom: null,
      pricepsqmbuildingto: null,
      siteareafrom: null,
      siteareato: null,
      pricepsqmlandfrom: null,
      pricepsqmlandto: null,
      yieldamtfrom: null,
      yieldamtto: null,
      broadspace: null,
      spaceuse: null,
      titlebasis: null,
      salesmethod: null,
      buildingname: null,
      streetname: null,
      suburb: null,
      postcode: null,
      state: null,
      agent: null,
      agency: null,
      buyer: null,
      vendor: null,
      saletype: null,
      transferno: null,
      transfernonull: null,
      transfernoduplicate: null,
      pricenull: null,
      isLoading: true,

      search_count: 0,
      filter: {},
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.exportRecords = this.exportRecords.bind(this);
  }

  async componentDidMount() {
    if (!this.props.isAuthenticated) {
      // if false
      return;
    }

    this.getStates({});
    document.title = "SLM Sales Search";
    this.setState({ isLoading: false });
  }

  async getSales(filter) {
    console.log("Inside getSales()");

    console.log(filter);

    //  this.setState({ searching : true });

    return await API.get("colin", "/slmsales", { queryStringParameters: filter });
  }

  getSalesExport(filter) {
    console.log("Inside getSalesExport()");

    console.log(filter);

    //  this.setState({ searching : true });

    return API.get("colin", "/slmsalesexport", { queryStringParameters: filter });
  }
  getOwnerIsCompanyMapping(filter) {
    return API.get("colin", "/slmiscompanynamescreening", { queryStringParameters: filter });
  }
  getSalesClientExport(filter) {
    console.log("Inside getSalesClientExport()");

    console.log(filter);

    //  this.setState({ searching : true });

    return API.get("colin", "/slmsalesclientexport", { queryStringParameters: filter });
  }

  getStates() {
    try {
      API.get("colin", `/slmstates`, { cancelToken: source.token }).then((stateOptions) => {
        if (stateOptions) {
          this.setState((state) => ({ stateOptions }));
        }
      });
    } catch {
      console.log("Error getting states");
    }
  }

  handleChange = (event) => {
    console.log("Inside handleChange");
    this.setState({
      [event.target.id]: event.target.value,
    });
  };
  handleCheckboxChange = (event) => {
    console.log(event);
    this.setState({ [event.target.id]: event.target.checked });
  };
  handlePercentChange = (event) => {
    let val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({
      [event.target.id]: val,
    });
    this.setState({ modified: true });
  };

  handleNumberChange = (event) => {
    let val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({
      [event.target.id]: val,
    });
    this.setState({ modified: true });
  };

  handleDateChange(date, name) {
    if (date) {
      this.setState({
        [name]: new Date(date),
      });
    } else {
      this.setState({
        [name]: null,
      });
    }
    this.setState({ modified: true });
  }

  handleCheckBoxChange = (event) => {
    let name = event.target.name;
    this.setState(
      {
        [name]: event.target.checked,
        modified: true,
      },
      this.handleBlur
    );
  };

  handleStateChange = (selectedState) => {
    if (selectedState) {
      this.setState({ selectedState });
      this.setState({ state: selectedState.value });
    } else {
      this.setState({ selectedState: { value: null, label: null } });
      this.setState({ state: null });
    }

    this.setState({ modified: true });
  };

  handleBroadSpaceUseChange = async (selectedBroadSpaceUseCategories) => {
    if (selectedBroadSpaceUseCategories) {
      this.setState({ selectedBroadSpaceUseCategories, broadspace: selectedBroadSpaceUseCategories.value, modified: true, selectedSpaceUseCategories: { value: null, label: null }, space_use_id: null });
    } else {
      this.setState({ selectedBroadSpaceUseCategories: { value: null, label: null }, broadspace: null, modified: true, selectedSpaceUseCategories: { value: null, label: null }, spaceuse: null });
    }
  };

  handleSpaceUseChange = (selectedSpaceUseCategories) => {
    if (selectedSpaceUseCategories) {
      this.setState({ selectedSpaceUseCategories, spaceuse: selectedSpaceUseCategories.value, broadspace: selectedSpaceUseCategories.supplementary_details.broad_space_use_id, modified: true, selectedBroadSpaceUseCategories: { value: selectedSpaceUseCategories.supplementary_details.broad_space_use_id, label: selectedSpaceUseCategories.supplementary_details.broad_space_use_code } });
    } else {
      this.setState({ selectedSpaceUseCategories: { value: null, label: null }, spaceuse: null, modified: true });
    }
  };

  handleSpaceUseChange = (selectedSpaceUseCategories) => {
    if (selectedSpaceUseCategories) {
      this.setState({ selectedSpaceUseCategories, spaceuse: selectedSpaceUseCategories.value, modified: true, selectedBroadSpaceUseCategories: { value: selectedSpaceUseCategories.supplementary_details.broad_space_use_id, label: selectedSpaceUseCategories.supplementary_details.broad_space_use_code } });
    } else {
      this.setState({ selectedSpaceUseCategories: { value: null, label: null }, spaceuse: null, modified: true });
    }
  };

  handleTitleBasisChange = (selectedTitleBasisCategories) => {
    if (selectedTitleBasisCategories) {
      this.setState({ selectedTitleBasisCategories, titlebasis: selectedTitleBasisCategories.value, modified: true });
    } else {
      this.setState({ selectedTitleBasisCategories: { value: null, label: null } });
      this.setState({ titlebasis: null, modified: true });
    }
  };

  handleSaleMethodChange = (selectedSaleMethodCategories) => {
    if (selectedSaleMethodCategories) {
      this.props.saleTypes.filter((a) => {
        if (a.value === selectedSaleMethodCategories.value) {
          return true;
        } else {
          return false;
        }
      });

      this.setState({ selectedSaleMethodCategories, salesmethod: selectedSaleMethodCategories.value, modified: true });
    } else {
      this.setState({ selectedSaleMethodCategories: { value: null, label: null }, salesmethod: null, modified: true });
    }
  };

  handleClientExportChange = (selectedClientExport) => {
    if (selectedClientExport) {
      this.setState({ selectedClientExport });
    } else {
      this.setState({ selectedClientExport: { value: null, label: null } });
    }
  };

  async handleSubmit(event) {
    console.log("HandleSubmit");
    event.preventDefault();
    this.setState({ isLoading: true });

    try {
      const sales = await this.getSales({
        createdby: this.state.createdby,
        editedby: this.state.editedby,
        printdatefrom: this.state.printdatefrom !== null ? Moment(this.state.printdatefrom).local().format() : "",
        printdateto: this.state.printdateto !== null ? Moment(this.state.printdateto).local().format() : "",
        statdatefrom: this.state.statdatefrom !== null ? Moment(this.state.statdatefrom).local().format() : "",
        statdateto: this.state.statdateto !== null ? Moment(this.state.statdateto).local().format() : "",
        pricefrom: this.state.pricefrom,
        priceto: this.state.priceto,
        pricepsqmbuildingfrom: this.state.pricepsqmbuildingfrom,
        pricepsqmbuildingto: this.state.pricepsqmbuildingto,
        siteareafrom: this.state.siteareafrom,
        siteareato: this.state.siteareato,
        pricepsqmlandfrom: this.state.pricepsqmlandfrom,
        pricepsqmlandto: this.state.pricepsqmlandto,
        yieldamtfrom: this.state.yieldamtfrom,
        yieldamtto: this.state.yieldamtto,
        broadspace: this.state.broadspace,
        spaceuse: this.state.spaceuse,
        titlebasis: this.state.titlebasis,
        salesmethod: this.state.salesmethod,
        buildingname: this.state.buildingname,
        streetname: this.state.streetname,
        suburb: this.state.suburb,
        postcode: this.state.postcode,
        state: this.state.state,
        agent: this.state.agent,
        agency: this.state.agency,
        buyer: this.state.buyer,
        vendor: this.state.vendor,
        saletype: this.state.saletype,
        transferno: this.state.transferno,
        transfernonull: this.state.transfernonull,
        transfernoduplicate: this.state.transfernoduplicate,
        pricenull: this.state.pricenull,
      });

      this.setState({ sales });
    } catch (error) {
      this.setState({ isLoading: false });
      alert(error + ". Please refresh the page (F5) to try again.");
      return;
    }

    this.setState((state) => ({
      filter: {
        createdby: this.state.createdby,
        editedby: this.state.editedby,
        printdatefrom: this.state.printdatefrom,
        printdateto: this.state.printdateto,
        statdatefrom: this.state.statdatefrom,
        statdateto: this.state.statdateto,
        pricefrom: this.state.pricefrom,
        priceto: this.state.priceto,
        pricepsqmbuildingfrom: this.state.pricepsqmbuildingfrom,
        pricepsqmbuildingto: this.state.pricepsqmbuildingto,
        siteareafrom: this.state.siteareafrom,
        siteareato: this.state.siteareato,
        pricepsqmlandfrom: this.state.pricepsqmlandfrom,
        pricepsqmlandto: this.state.pricepsqmlandto,
        yieldamtfrom: this.state.yieldamtfrom,
        yieldamtto: this.state.yieldamtto,
        broadspace: this.state.broadspace,
        spaceuse: this.state.spaceuse,
        titlebasis: this.state.titlebasis,
        salesmethod: this.state.salesmethod,
        buildingname: this.state.buildingname,
        streetname: this.state.streetname,
        suburb: this.state.suburb,
        postcode: this.state.postcode,
        state: this.state.state,
        agent: this.state.agent,
        agency: this.state.agency,
        buyer: this.state.buyer,
        vendor: this.state.vendor,
        saletype: this.state.saletype,
        transferno: this.state.transferno,
        transfernonull: this.state.transfernonull,
        transfernoduplicate: this.state.transfernoduplicate,
        pricenull: this.state.pricenull,
      },
      search_count: ++this.state.search_count,
    }));
    this.setState({ isLoading: false });
  }

  async clearFilters() {
    console.log("clearFilters");
    this.setState({
      createdby: "",
      editedby: "",
      printdatefrom: null,
      printdateto: null,
      statdatefrom: null,
      statdateto: null,
      pricefrom: "",
      priceto: "",
      pricepsqmbuildingfrom: "",
      pricepsqmbuildingto: "",
      siteareafrom: "",
      siteareato: "",
      pricepsqmlandfrom: "",
      pricepsqmlandto: "",
      yieldamtfrom: "",
      yieldamtto: "",
      buildingname: "",
      streetname: "",
      suburb: "",
      postcode: "",
      state: "",
      agent: "",
      agency: "",
      buyer: "",
      vendor: "",
      saletype: null,
      broadspace: null,
      spaceuse: null,
      titlebasis: null,
      salesmethod: null,
      transferno: null,
      transfernonull: null,
      transfernoduplicate: null,
      pricenull: null,
      selectedState: null,
      selectedSpaceUseCategories: null,
      selectedBroadSpaceUseCategories: null,
      selectedTitleBasisCategories: null,
      selectedSaleMethodCategories: null,
      filter: {
        user: this.props.user,
        screen: "sales",
      },
    });
  }

  exportRecords = async (event) => {
    const trigger = event.target.name;
    this.setState({ isLoading: true });
    let salesExport = {};
    if (trigger === "PIMS") {
      if (!this.state.printdatefrom || !this.state.printdatefrom) {
        alert("You must enter print date from and to before running an export");
        this.setState({ isLoading: false });
        return;
      }

      if (!this.state.state) {
        alert("You must select a state before running an export");
        this.setState({ isLoading: false });
        return;
      }
    }
    console.log(trigger);
    if (trigger === "PIMS") {
      salesExport = await this.getSalesExport({
        createdby: this.state.createdby,
        editedby: this.state.editedby,
        printdatefrom: this.state.printdatefrom !== null ? Moment(this.state.printdatefrom).local().format() : "",
        printdateto: this.state.printdateto !== null ? Moment(this.state.printdateto).local().format() : "",
        statdatefrom: this.state.statdatefrom !== null ? Moment(this.state.statdatefrom).local().format() : "",
        statdateto: this.state.statdateto !== null ? Moment(this.state.statdateto).local().format() : "",
        pricefrom: this.state.pricefrom,
        priceto: this.state.priceto,
        pricepsqmbuildingfrom: this.state.pricepsqmbuildingfrom,
        pricepsqmbuildingto: this.state.pricepsqmbuildingto,
        siteareafrom: this.state.siteareafrom,
        siteareato: this.state.siteareato,
        pricepsqmlandfrom: this.state.pricepsqmlandfrom,
        pricepsqmlandto: this.state.pricepsqmlandto,
        yieldamtfrom: this.state.yieldamtfrom,
        yieldamtto: this.state.yieldamtto,
        broadspace: this.state.broadspace,
        spaceuse: this.state.spaceuse,
        titlebasis: this.state.titlebasis,
        salesmethod: this.state.salesmethod,
        buildingname: this.state.buildingname,
        streetname: this.state.streetname,
        suburb: this.state.suburb,
        postcode: this.state.postcode,
        state: this.state.state,
        agent: this.state.agent,
        agency: this.state.agency,
        buyer: this.state.buyer,
        vendor: this.state.vendor,
        saletype: this.state.saletype,
      });
    } else {
      salesExport = await this.getSalesClientExport({
        createdby: this.state.createdby,
        editedby: this.state.editedby,
        printdatefrom: this.state.printdatefrom !== null ? Moment(this.state.printdatefrom).local().format() : "",
        printdateto: this.state.printdateto !== null ? Moment(this.state.printdateto).local().format() : "",
        statdatefrom: this.state.statdatefrom !== null ? Moment(this.state.statdatefrom).local().format() : "",
        statdateto: this.state.statdateto !== null ? Moment(this.state.statdateto).local().format() : "",
        pricefrom: this.state.pricefrom,
        priceto: this.state.priceto,
        pricepsqmbuildingfrom: this.state.pricepsqmbuildingfrom,
        pricepsqmbuildingto: this.state.pricepsqmbuildingto,
        siteareafrom: this.state.siteareafrom,
        siteareato: this.state.siteareato,
        pricepsqmlandfrom: this.state.pricepsqmlandfrom,
        pricepsqmlandto: this.state.pricepsqmlandto,
        yieldamtfrom: this.state.yieldamtfrom,
        yieldamtto: this.state.yieldamtto,
        broadspace: this.state.broadspace,
        spaceuse: this.state.spaceuse,
        titlebasis: this.state.titlebasis,
        salesmethod: this.state.salesmethod,
        buildingname: this.state.buildingname,
        streetname: this.state.streetname,
        suburb: this.state.suburb,
        postcode: this.state.postcode,
        state: this.state.state,
        agent: this.state.agent,
        agency: this.state.agency,
        buyer: this.state.buyer,
        vendor: this.state.vendor,
        saletype: this.state.saletype,
      });
    }
    // if(!salesExport){
    //     alert("No records to export");
    //     this.setState({ isLoading: false });
    //     return;
    // }
    this.setState({ salesExport });
    var today = new Date(this.state.printdateto);
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yy = today.getFullYear();
    var stateSuffix = "";
    switch (this.state.state) {
      case "ACT":
        stateSuffix = "a";
        break;
      case "NT":
        stateSuffix = "d";
        break;
      case "NSW":
        stateSuffix = "n";
        break;
      case "QLD":
        stateSuffix = "q";
        break;
      case "SA":
        stateSuffix = "s";
        break;
      case "TAS":
        stateSuffix = "t";
        break;
      case "VIC":
        stateSuffix = "v";
        break;
      case "WA":
        stateSuffix = "w";
        break;
      default:
        stateSuffix = "";
        break;
    }

    let fileName = "";
    if (trigger === "PIMS") {
      fileName = "s" + yy.toString().substring(2, 4) + ("0" + mm).slice(-2) + ("0" + dd).slice(-2) + stateSuffix + ".pim";
    } else {
      var clientSuffix = "";
      switch (this.state.selectedClientExport.value) {
        case "NAB":
          clientSuffix = "valex";
          break;
        case "CBRE":
          clientSuffix = "cbre";
          break;
        case "CL":
          clientSuffix = "cl";
          break;
        case "GAP":
          clientSuffix = "gapmaps";
          break;
        case "ONE":
          clientSuffix = "onemap";
          break;
        default:
          clientSuffix = "";
          break;
      }
      fileName = "s" + yy.toString().substring(2, 4) + ("0" + mm).slice(-2) + ("0" + dd).slice(-2) + clientSuffix + ".csv";
    }

    // this.file = new File([new Blob([html], { type: 'text/csv;charset=utf-8;', endings: 'native' })],fileName);
    // const folder = "article/intropgx";
    // const attachment = this.file
    //     ? await s3Upload(this.file, folder)
    //     : null;
    //     console.log("Attachment name-"+attachment);
    //     const url = await s3GetURL(attachment.replace('article/intropgx/',""),'article/intropgx');
    //     this.setState({url,fileName,html});
    var csvFile = "";
    if (trigger === "PIMS") {
      csvFile = salesExport[0]["results"]
        .map((r) => {
          return Object.values(r)
            .map((x) => {
              if (x === null) {
                return "";
              } else if (typeof x === "number") {
                return x;
              } else {
                return '"' + x.replace("\r", "").replace("\n", "") + '"';
              }
            })
            .join(",");
        })
        .join("\r\n");
    } else {
      switch (this.state.selectedClientExport.value) {
        case "NAB":
          csvFile = salesExport[0]["results"]
            .filter((r) => r.is_sold === true && r.price > 0)
            .map((r) => {
              return Object.values(r).join(",");
            })
            .join("\r\n");
          break;
        case "CBRE":
          csvFile =
            Object.keys(salesExport[0]["results"][0])
              .map((r, i) => {
                return this.state.cbreHeaderRow[i];
              })
              .join(",") + "\r\n";
          csvFile =
            csvFile +
            salesExport[0]["results"]
              .map((r) => {
                return Object.values(r)
                  .map((x) => {
                    if (typeof x === "number") {
                      return x;
                    } else {
                      return '"' + (x || "") + '"';
                    }
                  })
                  .join(",");
              })
              .join("\r\n");
          break;
        case "CL":
          csvFile = salesExport[0]["results"]
            .map((r) => {
              return Object.values(r).join(",");
            })
            .join("\r\n");
          break;
        case "GAP":
          csvFile = salesExport[0]["results"]
            .map((r) => {
              return Object.values(r).join(",");
            })
            .join("\r\n");
          break;
        case "ONE":
          csvFile = salesExport[0]["results"]
            .map((r) => {
              return Object.values(r).join(",");
            })
            .join("\r\n");
          break;
        default:
          csvFile = salesExport[0]["results"]
            .map((r) => {
              return Object.values(r).join(",");
            })
            .join("\n");
          break;
      }
    }

    var blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
    this.setState({ isLoading: false });
  };

  getIsCompanyNameCheck = async (event) => {
    if (!this.state.printdatefrom || !this.state.printdatefrom) {
      alert("You must enter print date from and to");
      this.setState({ isLoading: false });
      return;
    }

    const ownerIsCompanyMapping = await this.getOwnerIsCompanyMapping({
      createdby: this.state.createdby,
      editedby: this.state.editedby,
      printdatefrom: this.state.printdatefrom !== null ? Moment(this.state.printdatefrom).local().format() : "",
      printdateto: this.state.printdateto !== null ? Moment(this.state.printdateto).local().format() : "",
      statdatefrom: this.state.statdatefrom !== null ? Moment(this.state.statdatefrom).local().format() : "",
      statdateto: this.state.statdateto !== null ? Moment(this.state.statdateto).local().format() : "",
      pricefrom: this.state.pricefrom,
      priceto: this.state.priceto,
      pricepsqmbuildingfrom: this.state.pricepsqmbuildingfrom,
      pricepsqmbuildingto: this.state.pricepsqmbuildingto,
      siteareafrom: this.state.siteareafrom,
      siteareato: this.state.siteareato,
      pricepsqmlandfrom: this.state.pricepsqmlandfrom,
      pricepsqmlandto: this.state.pricepsqmlandto,
      yieldamtfrom: this.state.yieldamtfrom,
      yieldamtto: this.state.yieldamtto,
      broadspace: this.state.broadspace,
      spaceuse: this.state.spaceuse,
      titlebasis: this.state.titlebasis,
      salesmethod: this.state.salesmethod,
      buildingname: this.state.buildingname,
      streetname: this.state.streetname,
      suburb: this.state.suburb,
      postcode: this.state.postcode,
      state: this.state.state,
      agent: this.state.agent,
      agency: this.state.agency,
      buyer: this.state.buyer,
      vendor: this.state.vendor,
      saletype: this.state.saletype,
    });
    this.setState({ ownerIsCompanyMapping });
    this.setState({ showIndividualBuyerSeller: true });
  };

  updateTableState(data, set) {
    this.setState({
      [set]: data,
    });
  }

  renderSLMSales() {
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    const numberFormatter = new Intl.NumberFormat("en-AU", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return (
      <div>
        {this.state.isLoading && (
          <div className="outer-div">
            <div className="sweet-loading inner-div">
              <PacmanLoader
                css="display: block;
                            margin: 0 auto;
                             border-color: red"
                sizeUnit={"px"}
                size={20}
                color={"#e03c31"}
                loading={this.state.isLoading}
              />
            </div>
          </div>
        )}
        {!this.state.isLoading && (
          <Container fluid>
            <Modal
              dialogClassName="modal-90w"
              show={this.state.showIndividualBuyerSeller}
              onHide={(e) => {
                this.setState({ showIndividualBuyerSeller: !this.state.showIndividualBuyerSeller });
              }}
              centered
            >
              <Modal.Header closeButton>
                {" "}
                <Modal.Title>Buyers/Sellers Not Flagged as a Business</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <SLMOwnerIsCompanyMapping isAuthenticated={this.props.isAuthenticated} isLoading={this.state.isLoading} data={this.state.ownerIsCompanyMapping} updateTableState={this.updateTableState} />
              </Modal.Body>
            </Modal>

            <Row>
              <Col sm={12} md={12} lg={12}>
                <p>
                  <b>SLM Sales</b>
                </p>
              </Col>
            </Row>
            <Row>
              <Col md={2} lg={2}>
                <Form onSubmit={this.handleSubmit}>
                  <Row>
                    <Col>
                      <Button type="submit" size="sm" id="submit">
                        Search
                      </Button>
                    </Col>
                    <Col>
                      <Button type="button" size="sm" onClick={this.clearFilters}>
                        Clear Filters
                      </Button>
                    </Col>
                  </Row>
                  <hr />

                  <br />
                  <Form.Row>
                    <Col>
                      <Form.Group controlId="saletype">
                        <Form.Check inline checked={this.state.saletype === "SOLD"} type="radio" label="SOLD" value="SOLD" onChange={this.handleChange} />
                        <Form.Check inline checked={this.state.saletype === "For Sale"} type="radio" label="For Sale" value="For Sale" onChange={this.handleChange} />

                        <Form.Check inline checked={this.state.saletype === "Both"} type="radio" label="Both" value="Both" onChange={this.handleChange} />
                      </Form.Group>
                    </Col>
                  </Form.Row>
                  <Form.Row>
                    <Col>
                      <Form.Group controlId="createdby">
                        <Form.Control type="input" value={this.state.createdby} onChange={this.handleChange} placeholder="Created By starting" />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group controlId="editedby">
                        <Form.Control type="input" value={this.state.editedby} onChange={this.handleChange} placeholder="Last Edited By starting" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col lg={4}>Print Date</Col>
                    <Col lg={4}>
                      <Form.Group controlId="printdatefrom">
                        <DatePicker
                          selected={this.state.printdatefrom !== null ? new Date(this.state.printdatefrom) : null}
                          onChange={(e) => this.handleDateChange(e, "printdatefrom")}
                          //   onBlur={this.handleBlur}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          isClearable={true}
                          placeholderText="From"
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="printdateto">
                        <DatePicker
                          selected={this.state.printdateto !== null ? new Date(this.state.printdateto) : null}
                          onChange={(e) => this.handleDateChange(e, "printdateto")}
                          //   onBlur={this.handleBlur}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          isClearable={true}
                          placeholderText="To"
                        />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col lg={4}>Stat Date</Col>
                    <Col lg={4}>
                      <Form.Group controlId="statdatefrom">
                        <DatePicker
                          selected={this.state.statdatefrom !== null ? new Date(this.state.statdatefrom) : null}
                          onChange={(e) => this.handleDateChange(e, "statdatefrom")}
                          //   onBlur={this.handleBlur}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          isClearable={true}
                          placeholderText="From"
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="statdateto">
                        <DatePicker
                          selected={this.state.statdateto !== null ? new Date(this.state.statdateto) : null}
                          onChange={(e) => this.handleDateChange(e, "statdateto")}
                          //   onBlur={this.handleBlur}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          isClearable={true}
                          placeholderText="To"
                        />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col lg={4}>Price</Col>
                    <Col lg={4}>
                      <Form.Group controlId="pricefrom">
                        <Form.Control type="input" value={this.state.pricefrom ? formatter.format(this.state.pricefrom) : this.state.pricefrom} onChange={this.handleNumberChange} placeholder="From" />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="priceto">
                        <Form.Control type="input" value={this.state.priceto ? formatter.format(this.state.priceto) : this.state.priceto} onChange={this.handleNumberChange} placeholder="To" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col lg={4}></Col>
                    <Col>
                      <Form.Group controlId="pricenull">
                        <Form.Check checked={this.state.pricenull || false} onChange={this.handleCheckboxChange} label="Price Missing or $0" type="checkbox" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="transferno">
                        <Form.Control type="input" value={this.state.transferno} onChange={this.handleChange} placeholder="Transfer No containing" />
                      </Form.Group>
                    </Col>
                  </Form.Row>
                  <Form.Row>
                    <Col lg={4}></Col>
                    <Col>
                      <Form.Group controlId="transfernonull">
                        <Form.Check checked={this.state.transfernonull || false} onChange={this.handleCheckboxChange} label="Transfer No Missing" type="checkbox" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col lg={4}></Col>
                    <Col>
                      <Form.Group controlId="transfernoduplicate">
                        <Form.Check checked={this.state.transfernoduplicate || false} onChange={this.handleCheckboxChange} label="Duplicate Transfer Numbers" type="checkbox" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col lg={4}>Price Per SQM Bldg</Col>
                    <Col lg={4}>
                      <Form.Group controlId="pricepsqmbuildingfrom">
                        <Form.Control type="input" value={this.state.pricepsqmbuildingfrom ? formatter.format(this.state.pricepsqmbuildingfrom) : this.state.pricepsqmbuildingfrom} onChange={this.handleNumberChange} placeholder="From" />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="pricepsqmbuildingto">
                        <Form.Control type="input" value={this.state.pricepsqmbuildingto ? formatter.format(this.state.pricepsqmbuildingto) : this.state.pricepsqmbuildingto} onChange={this.handleNumberChange} placeholder="To" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col lg={4}>Site Area</Col>
                    <Col lg={4}>
                      <Form.Group controlId="siteareafrom">
                        <Form.Control type="input" value={this.state.siteareafrom ? numberFormatter.format(this.state.siteareafrom) : this.state.siteareafrom} onChange={this.handleNumberChange} placeholder="From" />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="siteareato">
                        <Form.Control type="input" value={this.state.siteareato ? numberFormatter.format(this.state.siteareafrom) : this.state.siteareato} onChange={this.handleNumberChange} placeholder="To" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col lg={4}>Price Per SQM Land</Col>
                    <Col lg={4}>
                      <Form.Group controlId="pricepsqmlandfrom">
                        <Form.Control type="input" value={this.state.pricepsqmlandfrom ? formatter.format(this.state.pricepsqmlandfrom) : this.state.pricepsqmlandfrom} onChange={this.handleNumberChange} placeholder="From" />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="pricepsqmlandto">
                        <Form.Control type="input" value={this.state.pricepsqmlandto ? formatter.format(this.state.pricepsqmlandto) : this.state.pricepsqmlandto} onChange={this.handleNumberChange} placeholder="To" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col lg={4}>Yield</Col>
                    <Col lg={4}>
                      <Form.Group controlId="yieldamtfrom">
                        <Form.Control type="input" value={this.state.yieldamtfrom ? this.state.yieldamtfrom + "%" : this.state.yieldamtfrom} onChange={this.handleNumberChange} placeholder="From" />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="yieldamtto">
                        <Form.Control type="input" value={this.state.yieldamtto ? this.state.yieldamtto + "%" : this.state.yieldamtto} onChange={this.handleNumberChange} placeholder="To" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="broadspaceuse">
                        <Select
                          value={this.state.selectedBroadSpaceUseCategories}
                          onChange={this.handleBroadSpaceUseChange}
                          options={this.props.broadspaceusecategoryOptions.filter((a) => {
                            if (a.value === this.state.broadspace || this.state.broadspace === null) {
                              return true;
                            } else {
                              return false;
                            }
                          })}
                          isClearable
                          placeholder="Broad Use"
                        />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="spaceuse">
                        <Select
                          value={this.state.selectedSpaceUseCategories}
                          onChange={this.handleSpaceUseChange}
                          options={this.props.spaceusecategoryOptions.filter((a) => {
                            if (a.supplementary_details.broad_space_use_id === this.state.broadspace || this.state.broadspace === null) {
                              return true;
                            } else {
                              return false;
                            }
                          })}
                          isClearable
                          //isDisabled={!this.state.broad_space_use_id?true:false}
                          placeholder="Space Use"
                        />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="titlebasis">
                        <Select value={this.state.selectedTitleBasisCategories} onChange={this.handleTitleBasisChange} options={this.props.titlebasiscategoryOptions} isClearable placeholder="Title Basis" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="salesmethod">
                        <Select value={this.state.selectedSaleMethodCategories} onChange={this.handleSaleMethodChange} options={this.props.salemethodcategoryOptions} placeholder="Sale Method" isClearable />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="buildingname">
                        <Form.Control type="input" value={this.state.buildingname} onChange={this.handleChange} placeholder="Building Name containing" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="streetname">
                        <Form.Control type="input" value={this.state.streetname} onChange={this.handleChange} placeholder="Street Name starting" />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="streetext">
                        <Form.Control type="input" value={this.state.streetext} onChange={this.handleChange} placeholder="Street Ext" />
                      </Form.Group>
                    </Col>
                  </Form.Row>
                  <Form.Row>
                    <Col>
                      <Form.Group controlId="suburb">
                        <Form.Control type="input" value={this.state.suburb} onChange={this.handleChange} placeholder="Suburb starting" />
                      </Form.Group>
                    </Col>
                  </Form.Row>
                  <Form.Row>
                    <Col>
                      <Form.Group controlId="state">
                        <Select value={this.state.selectedState} onChange={this.handleStateChange} options={this.state.stateOptions} onInputChange={this.handleInputChange} onBlur={this.handleBlur} placeholder="Select a state" isClearable />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="postcode">
                        <Form.Control type="input" value={this.state.postcode} onChange={this.handleChange} placeholder="Postcode" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="agent">
                        <Form.Control type="input" value={this.state.agent} onChange={this.handleChange} placeholder="Agent containing" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="agency">
                        <Form.Control type="input" value={this.state.agency} onChange={this.handleChange} placeholder="Agency containing" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="buyer">
                        <Form.Control type="input" value={this.state.buyer} onChange={this.handleChange} placeholder="Buyer containing" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="vendor">
                        <Form.Control type="input" value={this.state.vendor} onChange={this.handleChange} placeholder="Vendor containing" />
                      </Form.Group>
                    </Col>
                  </Form.Row>
                  <Row>
                    <Col>
                      <Button type="button" name="PIMS" onClick={this.exportRecords}>
                        Export PIMS
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <br />
                      <Button type="button" onClick={this.getIsCompanyNameCheck}>
                        Review Individual Buyer/Sellers
                      </Button>
                    </Col>
                  </Row>

                  {/* <Form.Row>
                            <Col>
                                <Select
                                    value={this.state.selectedClientExport}
                                    onChange={this.handleClientExportChange}
                                    options={this.state.clientExports}
                              
                                    onBlur={this.handleBlur}
                                    placeholder="Client"
                                    
                                /></Col>
                                <Col><Button type="button" size="sm" name="CLIENT" onClick={this.exportRecords} >Export Client Extract</Button></Col>
                                
                            </Form.Row> */}
                </Form>
              </Col>
              <Col md={10} lg={10}>
                <Row>
                  <Col sm={12} md={12} lg={12}>
                    <SLMSaleList filter={this.state.filter} isAuthenticated={this.props.isAuthenticated} isLoading={this.state.isLoading} data={this.state.sales} clientExports={this.state.clientExports} selectedClientExport={this.state.selectedClientExport} handleClientExportChange={this.handleClientExportChange} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        )}
      </div>
    );
  }
  render() {
    return <div className="SLMSaleSearch">{this.props.isAuthenticated ? this.renderSLMSales() : console.log("error)")}</div>;
  }
}
